import React, {useEffect, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import Spinner from "reactjs-simple-spinner";
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import {Card, CardActionArea, CardActions, CardContent, InputLabel, MenuItem} from "@material-ui/core";
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AttachmentIcon from '@material-ui/icons/Attachment';
import InfoIcon from '@material-ui/icons/Info';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import BeneficiaryService from "../../../services/BeneficiaryService";
import FilesService from "../../../services/FilesService";
import PoliciesService from "../../../services/PoliciesService";
import PaymentsService from "../../../services/PaymentsService";
import IlifaSummaryToPrint from "./IlifaSummaryToPrint";


function getModalStyle() {
    const top = 40;
    const left = 40;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

function getPrintModalStyle() {
    const top = 40;
    const left = 40;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        height: 700,
        overflowY: 'auto'
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        width: "45%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
    printPaper: {
        position: 'absolute',
        width: "70%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
}));

//beneficiary init
const initialBeneficiary = {
    name: "",
    surname: "",
    relationship: "",
    date_of_birth: "",
    id_number: null,
    mobile_number: "",
    policy_id: ""
}

const initialPaymentObject = {
    payment_method: 'CASH',
    payment_channel: '',
    currency_id: '',
    amount: '',
    reference_number: ""
}

const ViewNhakaYangu = (props) => {

    let history = useHistory();
    const classes = useStyles();
    const [policy, setPolicy] = useState({})
    const [agent, setAgent] = useState({})
    const [aggregator, setAggregator] = useState({})
    const [manager, setManager] = useState({})
    const [representative, setRepresentative] = useState({})
    const [policyId, setPolicyId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingPolicy, setLoadingPolicy] = useState(false);
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    const [printModalStyle] = React.useState(getPrintModalStyle)
    const [open, setOpen] = React.useState(false);

    //add or update loading variables
    const [addBeneficiaryLoading, setAddBeneficiaryLoading] = useState(false);
    const [updateBeneficiaryLoading, setUpdateBeneficiaryLoading] = useState(false);

    //objects init
    const [beneficiary, setBeneficiary] = useState(initialBeneficiary);
    const [beneficiaries, setBeneficiaries] = useState([]);

    //files
    const [uploadLoading, setUploadLoading] = useState(false);
    const [uploadDeductionLoading, setUploadDeductionLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [deductionMessage, setDeductionMessage] = useState('');

    //payments
    const [payment, setPayment] = useState(initialPaymentObject)
    const [currencies, setCurrencies] = useState([])
    const [editButton, setEditButton] = useState(false)
    const [paymentButton, setPaymentButton] = useState(false)

    const handleChange = name => ({target: {value}}) => {
        setPayment({...payment, [name]: value})
    }

    const handleSubmitPayment = () => {
        setLoading(true);
        console.log("data: ", payment)
        if (payment.amount === null || payment.amount === '') {
            setLoading(false);
            toast.warning('Please enter amount', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return
        }

        if (payment.currency_id === null || payment.currency_id === '') {
            setLoading(false);
            toast.warning('Please select currency', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return
        }

        if (policy.payment_method === 'CASH') {

            // noinspection BadExpressionStatementJS
            PaymentsService.addCashPayment(payment, policyId)
                .then(res => {
                    console.log("res: ", res);
                    if (res.status === 200 || res.status === 201) {
                        setPolicy(res.data.policy)
                        setLoading(false);
                        toast.success('Payment Added Successfully!', {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    } else {
                        setLoading(false);
                        toast.warning('Payment failed, Please try again', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }).catch(err => {
                setLoading(false);
                console.log(err);
                toast.warning('Payment failed, Please try again \n Error: ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
        } else if (policy.payment_method === 'STOP_ORDER') {

            // noinspection BadExpressionStatementJS
            PaymentsService.addCashPayment(payment, policyId)
                .then(res => {
                    console.log("res: ", res);
                    if (res.status === 200 || res.status === 201) {
                        setPolicy(res.data.policy)
                        setLoading(false);
                        toast.success('Payment Added Successfully!', {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    } else {
                        setLoading(false);
                        toast.warning('Payment failed, Please try again', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }).catch(err => {
                setLoading(false);
                console.log(err);
                toast.warning('Payment failed, Please try again \n Error: ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
        }


    }


    //download loading
    const [downloadLoading, setDownloadLoading] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    //print modal
    const [printOpen, setPrintOpen] = React.useState(false);

    const handlePrintOpen = () => {
        setPrintOpen(true);
    };

    const handlePrintClose = () => {
        setPrintOpen(false);
    };

    //add beneficiary
    const [beneficiaryOpen, setBeneficiaryOpen] = React.useState(false);

    const handleBeneficiaryOpen = () => {
        setBeneficiaryOpen(true);
    };

    const handleBeneficiaryClose = () => {
        setBeneficiaryOpen(false);
    };


    /***
     * handle change functions
     */

    const handleBeneficiaryChange = name => ({target: {value}}) => {
        console.log("ben: ", beneficiary);
        setBeneficiary({...beneficiary, [name]: value});
    }



    /***
     * End of functions
     */

    /**
     * Submit and update functions
     * Add Beneficiary
     **/
    const handleAddBeneficiary = () => {
        setAddBeneficiaryLoading(true);
        console.log("benef: ", beneficiary);
        BeneficiaryService.addBeneficiary(beneficiary, policyId).then(res => {
            console.log("res: ", res)
            //    if status 200 hide add button
            if (res.status === 200) {
                toast.success('Beneficiary Added Successfully!', {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                });
                setAddBeneficiaryLoading(false);
                //handleClose
                handleBeneficiaryClose()
                setLoading(true);
                BeneficiaryService.getBeneficiaries(policyId).then(res => {
                    console.log("beneficiary: ", res.data.beneficiary);
                    //if true hide add button
                    if (res.data.beneficiary.length === 0) {
                        setBeneficiaries([]);
                        setLoading(false);
                    } else {
                        setBeneficiary(res.data.beneficiary[0]);
                        setBeneficiaries(res.data.beneficiary);
                        setLoading(false);
                    }
                    setLoading(false);
                }).catch(err => {
                    toast.warning('Loading Beneficiary Failed \n If error persists contact, System Administrator', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    console.log("error: ", err);
                    setLoading(false);
                })
            } else {
                toast.warning('Adding Beneficiary Failed \n If error persists contact, System Administrator', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setAddBeneficiaryLoading(false);
            }
        }).catch(err => {
            toast.warning('Adding Beneficiary Failed \n If error persists contact, System Administrator', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log("error: ", err);
            setAddBeneficiaryLoading(false);
        })
    }



    const handleUpdateBeneficiary = () => {
        setUpdateBeneficiaryLoading(true);
        console.log("benef: ", beneficiary);
        BeneficiaryService.updateBeneficiary(beneficiary).then(res => {
            console.log("res: ", res)
            //    if status 200 hide add button
            if (res.status === 200) {
                toast.success('Beneficiary Updated Successfully!', {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateBeneficiaryLoading(false);
                //handleClose
                handleClose()
                setLoading(true);
                BeneficiaryService.getBeneficiaries(policyId).then(res => {
                    console.log("beneficiary: ", res.data.beneficiary);
                    //if true hide add button
                    if (res.data.beneficiary.length === 0) {
                        setLoading(false);
                    } else {
                        setBeneficiary(res.data.beneficiary[0]);
                        setLoading(false);
                    }
                    setLoading(false);
                }).catch(err => {
                    toast.warning('Loading Beneficiary Failed \n If error persists contact, System Administrator', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    console.log("error: ", err);
                    setLoading(false);
                })
            } else {
                toast.warning('Updating Beneficiary Failed \n If error persists contact, System Administrator', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateBeneficiaryLoading(false);
            }
        }).catch(err => {
            toast.warning('Updating Beneficiary Failed \n If error persists contact, System Administrator', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log("error: ", err);
            setUpdateBeneficiaryLoading(false);
        })

    }


    /***
     * End of functions
     */

    /***
     * delete functions
     */
    const handleDeleteBeneficiary = (row) => {
        setLoading(true);
        console.log("benef: ", row);
        BeneficiaryService.deleteBeneficiary(row).then(res => {
            console.log("res: ", res)
            //    if status 200 hide add button
            if (res.status === 200) {
                toast.success('Beneficiary Deleted Successfully!', {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                });


                setLoading(true);

                BeneficiaryService.getBeneficiaries(policyId).then(res => {
                    console.log("beneficiary: ", res.data.beneficiary);
                    //if true hide add button
                    if (res.data.beneficiary.length === 0) {
                        setLoading(false);
                        setBeneficiary(initialBeneficiary);
                    } else {
                        setBeneficiary(res.data.beneficiary[0]);
                        setLoading(false);
                    }
                    setLoading(false);
                }).catch(err => {
                    toast.warning('Deleting Beneficiary Failed \n If error persists contact, System Administrator', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    console.log("error: ", err);
                    setLoading(false);
                })
            } else {
                toast.warning('Deleting Beneficiary Failed \n If error persists contact, System Administrator', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLoading(false);
            }
        }).catch(err => {
            toast.warning('Deleting Beneficiary Failed \n If error persists contact, System Administrator', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log("error: ", err);
            setLoading(false)
        })

    }

    /***
     * End Functions
     */

    /***
     * File functions
     */
        //upload functions
    const handleFileChange = (e) => {
            setUploadLoading(true);
            console.log("e: ", e.target.name);
            console.log(e.target.files);
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append(e.target.name, file);

            if (policy.policy_type === 'ACCIDENT') {
                FilesService.accidentUploadFile(formData, policy.policy_holder_id)
                    .then(res => {
                        console.log(res);
                        setMessage(res.data.application_form);

                        setPolicy({...policy, 'application_form': res.data.application_form})
                        updatePolicy()
                        setUploadLoading(false);
                    })
                    .catch(err => {
                        setUploadLoading(false);
                        setMessage('');
                        console.log(err);
                    });
            } else if (policy.policy_type === 'COMPREHENSIVE') {
                FilesService.comprehensiveUploadFile(formData, policy.policy_holder_id)
                    .then(res => {
                        console.log(res);
                        setUploadLoading(false);
                        setMessage(res.data.application_form);

                        setPolicy({...policy, 'application_form': res.data.application_form})
                    })
                    .catch(err => {
                        setUploadLoading(false);
                        setMessage('');
                        console.log(err);
                    });
            } else if (policy.policy_type === 'FUNERAL') {
                FilesService.funeralUploadFile(formData, policy.policy_holder_id)
                    .then(res => {
                        console.log(res);
                        setUploadLoading(false);
                        setMessage(res.data.application_form);

                        setPolicy({...policy, 'application_form': res.data.application_form})
                    })
                    .catch(err => {
                        setUploadLoading(false);
                        setMessage('');
                        console.log(err);
                    });
            } else if (policy.policy_type === 'SAVINGS') {
                FilesService.savingsUploadFile(formData, policy.policy_holder_id)
                    .then(res => {
                        console.log(res);
                        setUploadLoading(false);
                        updatePolicy()
                        setMessage(res.data.application_form);

                        setPolicy({...policy, 'application_form': res.data.application_form})
                    })
                    .catch(err => {
                        setUploadLoading(false);
                        setMessage('');
                        console.log(err);
                    });
            }

        }

    const handleDeductionFileChange = (e) => {
        setUploadDeductionLoading(true);
        console.log("e: ", e.target.name);
        console.log(e.target.files);
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append(e.target.name, file);
        if (policy.policy_type === 'ACCIDENT') {
            FilesService.accidentUploadFile(formData, policy.policy_holder_id)
                .then(res => {
                    console.log(res);
                    setUploadDeductionLoading(false);
                    setDeductionMessage(res.data.deduction_form);
                    setPolicy({...policy, 'deduction_form': res.data.deduction_form})
                })
                .catch(err => {
                    setUploadDeductionLoading(false);
                    setDeductionMessage('');
                    console.log(err);
                });
        } else if (policy.policy_type === 'COMPREHENSIVE') {
            FilesService.comprehensiveUploadFile(formData, policy.policy_holder_id)
                .then(res => {
                    console.log(res);
                    setUploadDeductionLoading(false);
                    setDeductionMessage(res.data.deduction_form);
                    setPolicy({...policy, 'deduction_form': res.data.deduction_form})
                })
                .catch(err => {
                    setUploadDeductionLoading(false);
                    setDeductionMessage('');
                    console.log(err);
                });
        } else if (policy.policy_type === 'FUNERAL') {
            FilesService.funeralUploadFile(formData, policy.policy_holder_id)
                .then(res => {
                    console.log(res);
                    setUploadDeductionLoading(false);
                    setDeductionMessage(res.data.deduction_form);
                    setPolicy({...policy, 'deduction_form': res.data.deduction_form})
                })
                .catch(err => {
                    setUploadDeductionLoading(false);
                    setDeductionMessage('');
                    console.log(err);
                });
        } else if (policy.policy_type === 'SAVINGS') {
            FilesService.savingsUploadFile(formData, policy.policy_holder_id)
                .then(res => {
                    console.log(res);
                    setUploadDeductionLoading(false);
                    setDeductionMessage(res.data.deduction_form);
                    setPolicy({...policy, 'deduction_form': res.data.deduction_form})
                })
                .catch(err => {
                    setUploadDeductionLoading(false);
                    setDeductionMessage('');
                    console.log(err);
                });
        }

    }

    const updatePolicy = () => {
        setLoading(true);
        console.log("policyData", policy)
        PoliciesService.updatePolicy(policy)
            .then(res => {
                console.log(res);
                setPolicy(res.data.policy)
                setLoading(false);
                toast.success('File Upload Successful');
            }).catch(err => {
            console.log(err);
            toast.warning('File Upload Failed, Try again \nIf error persists contact System Administrator')
            setLoading(false);
        })
    }

    //download functions
    const handleDownloadApplicationForm = () => {
        setDownloadLoading(true);
        console.log("file: ", policy.application_form);
        let request = {
            fileName: "application_form",
            file_url: policy.application_form
        }

        if (policy.policy_type === 'ACCIDENT') {
            //    download accident
            FilesService.accidentDownloadFile(policy.policy_holder_id, request)
                .then(res => {
                    console.log(res);
                    setDownloadLoading(false);
                })
                .catch(err => {
                    setDownloadLoading(false);
                    console.log(err);
                });

        } else if (policy.policy_type === 'SAVINGS') {
            //    download savings
            FilesService.savingsDownloadFile(policy.policy_holder_id, request)
                .then(res => {
                    console.log(res);
                    setDownloadLoading(false);
                })
                .catch(err => {
                    setDownloadLoading(false);
                    console.log(err);
                });

        } else if (policy.policy_type === 'FUNERAL') {
            //    download funeral
            FilesService.funeralDownloadFile(policy.policy_holder_id, request)
                .then(res => {
                    console.log(res);
                    setDownloadLoading(false);
                })
                .catch(err => {
                    setDownloadLoading(false);
                    console.log(err);
                });

        } else if (policy.policy_type === 'COMPREHENSIVE') {
            //    download comprehensive
            FilesService.comprehensiveDownloadFile(policy.policy_holder_id, request)
                .then(res => {
                    console.log(res);
                    setDownloadLoading(false);
                })
                .catch(err => {
                    setDownloadLoading(false);
                    console.log(err);
                });

        }

    }

    const handleDownloadDeduction = () => {

        setDownloadLoading(true);
        console.log("file: ", policy.application_form);
        let request = {
            fileName: "deduction_form",
            file_url: policy.deduction_form
        }

        if (policy.policy_type === 'ACCIDENT') {
            //    download accident
            FilesService.accidentDownloadFile(policy.policy_holder_id, request)
                .then(res => {
                    console.log(res);
                    setDownloadLoading(false);
                })
                .catch(err => {
                    setDownloadLoading(false);
                    console.log(err);
                });

        } else if (policy.policy_type === 'SAVINGS') {
            //    download savings
            FilesService.savingsDownloadFile(policy.policy_holder_id, request)
                .then(res => {
                    console.log(res);
                    setDownloadLoading(false);
                })
                .catch(err => {
                    setDownloadLoading(false);
                    console.log(err);
                });

        } else if (policy.policy_type === 'FUNERAL') {
            //    download funeral
            FilesService.funeralDownloadFile(policy.policy_holder_id, request)
                .then(res => {
                    console.log(res);
                    setDownloadLoading(false);
                })
                .catch(err => {
                    setDownloadLoading(false);
                    console.log(err);
                });

        } else if (policy.policy_type === 'COMPREHENSIVE') {
            //    download comprehensive
            FilesService.comprehensiveDownloadFile(policy.policy_holder_id, request)
                .then(res => {
                    console.log(res);
                    setDownloadLoading(false);
                })
                .catch(err => {
                    setDownloadLoading(false);
                    console.log(err);
                });

        }


    }
    /***
     * end file functions
     */

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);
        setLoadingPolicy(true);
        setDownloadLoading(false);
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {

            setEditButton(false)
            setPaymentButton(false)
        } else {
            role_based_perm.map((perm, i) => {

                if (perm.name === 'update policies') {
                    setEditButton(true);
                }
                if (perm.name === 'update policy holder') {
                    setEditButton(true);
                }
                if (perm.name === 'make payments') {
                    setPaymentButton(true);
                }
            })
        }
        if (direct_perm === null || direct_perm === undefined) {

            setEditButton(false)
            setPaymentButton(false)
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'update policies') {
                    setEditButton(true);
                }
                if (perm.name === 'update policy holder') {
                    setEditButton(true);
                }
                if (perm.name === 'make payments') {
                    setPaymentButton(true);
                }
            })
        }
        //
        console.log("policy_id: ", JSON.parse(localStorage.getItem('policyId')))
        console.log("policyholder: ", JSON.parse(localStorage.getItem('pHolder')))
        console.log("policy: ", JSON.parse(localStorage.getItem('policy')))
        let id = JSON.parse(localStorage.getItem('policyId'));
        // setPolicy(JSON.parse(localStorage.getItem('policy')))
        setPolicyId(JSON.parse(localStorage.getItem('policyId')));
        PoliciesService.getPolicy(id)
            .then(res => {
                console.log('policy from server: ', res.data)
                setPolicy(res.data.policy)
                setAgent(res.data.agent)
                setManager(res.data.manager)
                setRepresentative(res.data.representative)
                setAggregator(res.data.aggregator)
                setLoadingPolicy(false);
            })
            .catch(err => {
                toast.warning('Loading Policy Failed \n If error persists contact, System Administrator', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log("error: ", err);
                setLoadingPolicy(false);
            })
        //get beneficiary by policyId
        BeneficiaryService.getBeneficiaries(id).then(res => {

            if (res.status === 200) {
                console.log("beneficiary: ", res.data.beneficiary);
                //if true hide add button
                if (res.data.beneficiary.length === 0) {
                    setBeneficiaries([]);
                    setLoading(false);

                } else {
                    setBeneficiaries(res.data.beneficiary);
                    setBeneficiary(res.data.beneficiary[0]);
                    localStorage.setItem("beneficiary", JSON.stringify(res.data.beneficiary[0]));

                    setLoading(false);
                }
            } else {
                toast.warning('Loading Beneficiary Failed \n If error persists contact, System Administrator', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log("error: ", res);

                setLoading(false);
            }

            setLoading(false);
        }).catch(err => {
            toast.warning('Loading Beneficiary Failed \n If error persists contact, System Administrator', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log("error: ", err);

            setLoading(false);
        })


        let t = JSON.parse(localStorage.getItem('token'))

        //    get all currencies
        PaymentsService.getAllCurrencies(t).then(response => {
            if (response.status === 200) {
                console.log("res: ", response)
                setCurrencies(response.data.currencies)
                setLoading(false);
            } else {
                setCurrencies([])
                setLoading(false);
            }
        }).catch(err => {
            console.error(err)
            setCurrencies([])
            setLoading(false);
        })

    }, []);

    const viewAccount = () => {
        console.log(policy.policy_number);

        //store row record into localStorage
        localStorage.setItem('policyNumber', JSON.stringify(policy?.policy_number));

        //redirect to the specific page
        history.push('/view-account');

    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        console.log("policy: ", policy);

        policy.policy_status = "NEW_BUSINESS";

        console.log("updated policy: ", policy);

        //post data
        PoliciesService.updatePolicy(policy)
            .then(res => {
                if (res.status === 400) {
                    setLoading(false);
                    toast.warning('Wrong inputs! Please verify your details', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else if (res.status === 500) {
                    setLoading(false);
                    toast.warning('Operation Failed \n If error persists contact, System Administrator', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else if (res.status === 200) {
                    console.log("response" + res);
                    toast.success('Policy Released', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    //store policy and policyId
                    localStorage.setItem("policyId", JSON.stringify(res.data.policy.id));
                    localStorage.setItem("policyNumber", JSON.stringify(res.data.policy.policy_number));
                    localStorage.setItem("policy", JSON.stringify(res.data.policy));
                    setLoading(false);
                } else {
                    setLoading(false);
                    toast.warning('Operation Failed \n If error persists contact, System Administrator', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            })
            .catch(err => {
                setLoading(false);
                toast.warning('Operation Failed \n If error persists contact, System Administrator', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            });
    }


    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>

            <div id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                {loadingPolicy && (
                    <div className="container">
                        <form className="loader">
                            <div className="login-wrap p-5 mt-5">
                                <Spinner
                                    size="large"
                                    message="Loading data, Please Wait..."
                                    line-fg-color="#64c3c2"
                                />
                            </div>
                        </form>
                    </div>
                )}
                {!loadingPolicy && (
                    <div className="content">
                        {loading && (
                            <div className="container">
                                <form className="loader">
                                    <div className="login-wrap p-5 mt-5">
                                        <Spinner
                                            size="large"
                                            message="Loading data, Please Wait..."
                                            line-fg-color="#64c3c2"
                                        />
                                    </div>
                                </form>
                            </div>
                        )}
                        {!loading && (
                            <div className="container-fluid">
                                <ul className="breadcrumb">
                                    <Link to={'/view-policy-holder'}><i
                                        className="fa fa-backward"/> Back</Link>    &nbsp;|
                                    Details For Policy Number &nbsp;
                                    <span
                                        className="text-primary font-weight-bold">{policy.policy_number}</span>
                                </ul>

                                <div className="row">
                                    <div className="col-lg-12">


                                        <div className="content-panel p-3">
                                            <hr/>
                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <h4 className="text-primary"><strong>
                                                        <InfoIcon fontSize="medium"/>&nbsp;
                                                        General Information</strong></h4>
                                                </div>
                                            </div>
                                            <hr/>

                                            <div className="row mt-1">
                                                <div className="col-md-3">
                                                    <h5><b>Policy Number:</b> <span>{policy.policy_number}</span>
                                                    </h5>
                                                </div>
                                                <div className="col-md-3">
                                                    <h5><b>Policy Type:</b> <span>{policy.policy_type}</span>
                                                    </h5>
                                                </div>

                                                <div className="col-md-3">
                                                    <h5><b>Commencement Date:</b>
                                                        <span>{policy.commencement_date}</span>
                                                    </h5>
                                                </div>
                                                <div className="col-md-3">
                                                    <h5><b>Industry:</b> <span>{policy.industry}</span>
                                                    </h5>
                                                </div>
                                                <div className="col-md-3">
                                                    <h5><b>Policy Status:</b> <span>{policy.policy_status}</span>
                                                        &nbsp;
                                                        {policy.policy_status === 'DORMANT' && (
                                                            <button onClick={handleSubmit}
                                                                    className="btn btn-sm btn-success">Release
                                                                Policy&nbsp; <i className="fas fa-check-double"></i>
                                                            </button>
                                                        )}
                                                    </h5>
                                                </div>
                                                <div className="col-md-3">
                                                    <h5><b>Premium Payer:</b> <span>{policy.premium_payer}</span>
                                                    </h5>
                                                </div>
                                                <div className="col-md-3">
                                                    <h5><b>Financial Advisor Code:</b>
                                                        <span>{policy.financial_advisor_reference}</span>
                                                    </h5>
                                                </div>
                                                <div className="col-md-3">
                                                    <h5><b>Policy Currency: </b>
                                                        <span> {policy.policy_currency}</span>
                                                    </h5>
                                                </div>


                                            </div>
                                            <div className="row mt-1">
                                                <div className="col-md-3">
                                                    <h5><b>Agent:</b> <span>{agent?.name}&nbsp;{agent?.surname}</span>
                                                    </h5>
                                                </div>
                                                <div className="col-md-3">
                                                    <h5><b>Manager:</b>
                                                        <span>{manager?.name}&nbsp;{manager?.surname}</span>
                                                    </h5>
                                                </div>

                                                <div className="col-md-3">
                                                    <h5><b>Aggregator:</b> <span>{aggregator?.name}</span>
                                                    </h5>
                                                </div>
                                                <div className="col-md-3">
                                                    <h5><b>Representative:</b>
                                                        <span>{representative?.first_name}&nbsp;{representative?.last_name}</span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <h4 className="text-primary">
                                                        <strong>
                                                            <AttachmentIcon fontSize="medium"/>&nbsp;
                                                            Forms</strong>
                                                    </h4>
                                                </div>
                                            </div>
                                            <hr/>

                                            {downloadLoading && (
                                                <div className="container">
                                                    <form className="loader">
                                                        <div className="login-wrap p-5 mt-5">
                                                            <Spinner
                                                                size="small"
                                                                message="Downloading, Please Wait..."
                                                                line-fg-color="#64c3c2"
                                                            />
                                                        </div>
                                                    </form>
                                                </div>
                                            )}
                                            {!loading && (
                                                <div className="row mt-1">

                                                    {!downloadLoading && (

                                                        <div className="row mt-2">
                                                            <div className="col-md-6">
                                                                {policy.application_form === null ? (
                                                                    <>
                                                                        {editButton && (
                                                                            <>
                                                                                <label htmlFor="inputEmail4"><span
                                                                                    className="text-muted small">(Optional)&nbsp;</span>
                                                                                    Application Form</label>
                                                                                <br/>
                                                                                <em className="text-muted">* You can
                                                                                    select file
                                                                                    to
                                                                                    upload</em>
                                                                                &nbsp;&nbsp;
                                                                                {/*<span style={{display: "none"}} id="uploadingLoader"/>*/}
                                                                                {uploadLoading && (
                                                                                    <div className="mt-2 mb-2 p-1">
                                                                                        <Spinner
                                                                                            size="small"
                                                                                            message="Uploading File....."
                                                                                            line-fg-color="#64c3c2"
                                                                                        />
                                                                                    </div>

                                                                                )}
                                                                                {message && !uploadLoading && (
                                                                                    <span className="text-success">
                                                            <br/>File Saved&nbsp;<i className="fa fa-check"/>
                                                            </span>
                                                                                )}


                                                                                <div>
                                                                                    <label
                                                                                        className="btn btn-sm btn-primary"
                                                                                        htmlFor="my-file-selector1">
                                                                                        <input required
                                                                                               id="my-file-selector1"
                                                                                               type="file"
                                                                                               name="application_form"
                                                                                               style={{display: "none"}}
                                                                                               accept=".pdf, .docx, .doc"
                                                                                               onChange={handleFileChange}
                                                                                        />
                                                                                        <i className="fa fa-folder-open"/>&nbsp;&nbsp;
                                                                                        Browse
                                                                                    </label>
                                                                                    <div className="p-3"/>
                                                                                    {message && (
                                                                                        <>
                                                                                 <span
                                                                                     className="form-control"
                                                                                     id="upload-file-info"
                                                                                 >{message}</span>
                                                                                            <button
                                                                                                onClick={updatePolicy}
                                                                                                className="btn btn-primary btn-sm">
                                                                                                <i className="fa fa-refresh"/>&nbsp; Update
                                                                                                Policy
                                                                                            </button>
                                                                                        </>

                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                        {!editButton && (
                                                                            <>
                                                                        <span className="text-uppercase text-center">
                                                                           <i className="fa-solid fa-file-circle-exclamation"></i>&nbsp;No Files Uploaded</span>
                                                                            </>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <h5>
                                                                        <button
                                                                            onClick={handleDownloadApplicationForm}
                                                                            className="btn btn-sm btn-primary">Download
                                                                            Proposal
                                                                            Form
                                                                            &nbsp; <i className="fa fa-cloud-download"/>
                                                                        </button>
                                                                    </h5>
                                                                )}
                                                            </div>
                                                            <div className="col-md-6">
                                                                {policy.deduction_form === null ? (
                                                                    <>
                                                                        {editButton && (
                                                                            <>
                                                                                <label htmlFor="inputEmail4">
                                                                    <span
                                                                        className="text-muted small">(Optional)&nbsp;</span>
                                                                                    Deduction Form</label>
                                                                                <br/>
                                                                                <em className="text-muted">* You can
                                                                                    select file
                                                                                    to
                                                                                    upload</em>
                                                                                &nbsp;&nbsp;
                                                                                {/*<span style={{display: "none"}} id="uploadingLoader"/>*/}
                                                                                {uploadDeductionLoading && (
                                                                                    <div className="mt-2 mb-2 p-1">
                                                                                        <Spinner
                                                                                            size="small"
                                                                                            message="Uploading File....."
                                                                                            line-fg-color="#64c3c2"
                                                                                        />
                                                                                    </div>

                                                                                )}
                                                                                {deductionMessage && !uploadDeductionLoading && (
                                                                                    <span className="text-success">
                                        <br/>File Saved&nbsp;<i className="fa fa-check"/>
                                    </span>
                                                                                )}
                                                                                <div>
                                                                                    <label
                                                                                        className="btn btn-sm btn-primary"
                                                                                        htmlFor="my-file-selector">
                                                                                        <input required
                                                                                               id="my-file-selector"
                                                                                               type="file"
                                                                                               name="deduction_form"
                                                                                               style={{display: "none"}}
                                                                                               accept=".pdf, .docx, .doc"
                                                                                               onChange={handleDeductionFileChange}
                                                                                        />
                                                                                        <i className="fa fa-folder-open"/>&nbsp;&nbsp;
                                                                                        Browse
                                                                                    </label>
                                                                                    <div className="p-3"/>
                                                                                    {deductionMessage && (
                                                                                        <>
                                                                            <span className="form-control"
                                                                                  id="upload-file-info"
                                                                            >{deductionMessage}</span>
                                                                                            <button
                                                                                                onClick={updatePolicy}
                                                                                                className="btn btn-primary btn-sm">
                                                                                                <i className="fa fa-refresh"/>&nbsp; Update
                                                                                                Policy
                                                                                            </button>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                        {!editButton && (
                                                                            <>
                                                                        <span className="text-uppercase text-center">
                                                                            <i className="fa-solid fa-file-circle-exclamation"></i>&nbsp;No Files Uploaded</span>
                                                                            </>
                                                                        )}

                                                                    </>
                                                                ) : (
                                                                    <h5>
                                                                        <button onClick={handleDownloadDeduction}
                                                                                className="btn btn-sm btn-primary">Download
                                                                            Deduction Form
                                                                            &nbsp; <i className="fa fa-cloud-download"/>
                                                                        </button>
                                                                    </h5>
                                                                )}

                                                            </div>
                                                        </div>
                                                    )}

                                                </div>
                                            )}

                                            <hr/>
                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <h4 className="text-primary"><strong><AccountBalanceIcon
                                                        fontSize="medium"/>&nbsp;Payment Information</strong></h4>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <a href onClick={() => viewAccount()}
                                                       className="btn text-white btn-sm btn-primary p-2">
                                                        <i className="fa fa-solid fa-warehouse"></i>&nbsp; View Account
                                                    </a>
                                                </div>
                                            </div>
                                            <hr/>
                                            {!loading && (
                                                <>
                                                    <div className="row mt-1">
                                                        <div className="col-md-3">
                                                            <h5><b>First Payment Date:</b>
                                                                <span>{policy.first_payment_date}</span>
                                                            </h5>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h5><b>Next Invoicing Date:</b>
                                                                <span>{policy.next_invoicing_date}</span>
                                                            </h5>
                                                        </div>

                                                        <div className="col-md-3">
                                                            <h5><b>Payment Frequency:</b>
                                                                <span>{policy.payment_frequency}</span>
                                                            </h5>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h5><b>Payment Method:</b>
                                                                <span>{policy.payment_method}</span>
                                                            </h5>
                                                        </div>

                                                    </div>
                                                    <div className="row mt-1">
                                                        {policy.policy_type !== 'SAVINGS' && policy.policy_type !== 'PFUMA / INOTHO' && (
                                                            <div className="col-md-3">
                                                                <h5><b>Sum Assured:</b>
                                                                    <span>{policy.sum_assured}</span>
                                                                </h5>
                                                            </div>
                                                        )}
                                                        <div className="col-md-3">
                                                            <h5><b>Primary Premium:</b> <span>{policy.premium}</span>
                                                            </h5>
                                                        </div>
                                                        {policy.payment_method === 'CASH' && (
                                                            <>
                                                                <div className="col-md-3">
                                                                    <h5><b>Mobile Account:</b>
                                                                        <span>{policy.mobile_account_name}</span>
                                                                    </h5>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h5><b>Mobile Number:</b>
                                                                        <span>{policy.mobile_number}</span>
                                                                    </h5>
                                                                </div>
                                                            </>
                                                        )}

                                                    </div>
                                                    {policy.payment_method === 'DEBIT_ORDER' && (

                                                        <div className="row mt-1">
                                                            <div className="col-md-3">
                                                                <h5><b>Bank:</b> <span>{policy.bank_name}</span>
                                                                </h5>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <h5><b>Branch:</b> <span>{policy.branch}</span>
                                                                </h5>
                                                            </div>

                                                            <div className="col-md-3">
                                                                <h5><b>Account Name:</b>
                                                                    <span>{policy.account_name}</span>
                                                                </h5>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <h5><b>Account Number:</b>
                                                                    <span>{policy.account_number}</span>
                                                                </h5>
                                                            </div>

                                                        </div>
                                                    )}

                                                    <div className="row mt-1">
                                                        <div className="col-md-3">
                                                            <h5><b>Contract Premium:</b>
                                                                <span>{policy.total_premium}</span>
                                                            </h5>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h5><b>Partial Payment:</b> <span>{policy.balance}</span>
                                                            </h5>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <h5><b>Arrears Balance:</b>
                                                                <span>{policy.arrearBalance}</span>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    {paymentButton && (
                                                        <>
                                                            <div className="row mt-3">

                                                                <div className="col-md-3">
                                                                    <TextField
                                                                        select
                                                                        onChange={handleChange('payment_channel')}
                                                                        name="paymentChannel"
                                                                        fullWidth
                                                                        required
                                                                        label="Select Payment Channel"
                                                                    >
                                                                        <MenuItem value disabled={true}>Select Payment
                                                                            Channel</MenuItem>
                                                                        <MenuItem value="CASH">Cash</MenuItem>
                                                                        <MenuItem value="ECOCASH">Ecocash</MenuItem>
                                                                        <MenuItem value="ONEMONEY">One Money</MenuItem>
                                                                        <MenuItem value="TELECASH">Telecash</MenuItem>
                                                                        <MenuItem value="RTGS">RTGS</MenuItem>
                                                                        <MenuItem value="ZIPIT">ZIPIT</MenuItem>
                                                                    </TextField>

                                                                </div>

                                                                <div className="col-md-3">
                                                                    <TextField
                                                                        select
                                                                        onChange={handleChange('currency_id')}
                                                                        name="currency_id"
                                                                        fullWidth
                                                                        required
                                                                        label="Select Currency"
                                                                    >
                                                                        <MenuItem value disabled={true} selected>Select
                                                                            Currency</MenuItem>
                                                                        {currencies.map((currency, i) => (
                                                                            <MenuItem key={i}
                                                                                      value={currency.id}>{currency.code}</MenuItem>
                                                                        ))}

                                                                    </TextField>

                                                                </div>

                                                                <div className="col-md-3">

                                                                    <TextField
                                                                        margin="dense"
                                                                        label="Amount"
                                                                        type="text"
                                                                        fullWidth
                                                                        value={payment.amount}
                                                                        onChange={handleChange('amount')}
                                                                    />

                                                                </div>
                                                                <div className="col-md-3">
                                                                    <TextField
                                                                        onChange={handleChange('reference_number')}
                                                                        name="reference_number"
                                                                        fullWidth
                                                                        label="Reference Number"
                                                                    />

                                                                </div>

                                                            </div>
                                                            <div className="rom mt-1">
                                                                <a href
                                                                   className="btn btn-sm btn-primary"
                                                                   onClick={handleSubmitPayment}
                                                                >
                                                                    <i className="fa fa-credit-card-alt"/>&nbsp;
                                                                    Make Payment
                                                                </a>
                                                            </div>
                                                        </>
                                                    )}

                                                </>
                                            )}

                                            <hr/>
                                            {loading && (
                                                <div className="container">
                                                    <form className="loader">
                                                        <div className="login-wrap p-5 mt-5">
                                                            <Spinner
                                                                size="large"
                                                                message="Loading beneficiaries, Please Wait..."
                                                                line-fg-color="#64c3c2"
                                                            />
                                                        </div>
                                                    </form>
                                                </div>
                                            )}
                                            {!loading && (
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <h4 className="text-primary"><strong><SupervisedUserCircleIcon
                                                            fontSize="medium"/>&nbsp;Beneficiaries </strong>
                                                        </h4>
                                                        <hr/>
                                                    </div>
                                                    {/*beneficiary*/}
                                                    <div className="col-md-12">
                                                        <h4 className="font-weight-bold ">Beneficiary</h4>
                                                        {/*if no beneficiary then show*/}
                                                        {editButton && (
                                                            <>
                                                                    <button onClick={handleBeneficiaryOpen}
                                                                            className="btn btn-sm btn-primary">
                                                                        Add Beneficiary &nbsp; <i
                                                                        className="fa fa-user-plus"/>
                                                                    </button>
                                                            </>
                                                        )}


                                                        <Card style={{maxWidth: "100%"}}>
                                                            <CardActionArea>
                                                                <CardContent>
                                                                    <TableContainer component={Paper}>
                                                                        <Table className={classes.table}
                                                                               aria-label="simple table">
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell>Name</TableCell>
                                                                                    <TableCell>Surname</TableCell>
                                                                                    <TableCell>Relationship</TableCell>
                                                                                    <TableCell
                                                                                        align="right">D.O.B</TableCell>
                                                                                    <TableCell align="right">ID
                                                                                        Number</TableCell>
                                                                                    <TableCell
                                                                                        align="right">Contact</TableCell>
                                                                                    {editButton && (
                                                                                        <TableCell
                                                                                            align="right">Actions</TableCell>
                                                                                    )}

                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                    {beneficiaries.map((beneficiary, i) => (
                                                                                <TableRow key={i}>
                                                                                    <TableCell component="th"
                                                                                               scope="row">
                                                                                        {beneficiary.name}
                                                                                    </TableCell>
                                                                                    <TableCell>{beneficiary.surname}</TableCell>
                                                                                    <TableCell>{beneficiary.relationship}</TableCell>
                                                                                    <TableCell
                                                                                        align="right">{beneficiary.date_of_birth}</TableCell>
                                                                                    <TableCell
                                                                                        align="right">{beneficiary.id_number}</TableCell>
                                                                                    <TableCell
                                                                                        align="right">{beneficiary.mobile_number}</TableCell>
                                                                                    {editButton && (
                                                                                        <TableCell align="right">
                                                                                            {beneficiary.name !== "" && (
                                                                                                <>
                                                                                                    <button
                                                                                                        onClick={handleOpen}
                                                                                                        className="btn btn-sm btn-primary">
                                                                                                        Edit
                                                                                                        Beneficiary &nbsp;
                                                                                                        <i
                                                                                                            className="fa fa-edit"/>
                                                                                                    </button>
                                                                                                    <button
                                                                                                        onClick={() => handleDeleteBeneficiary(beneficiary)}
                                                                                                        className="btn btn-sm btn-danger">
                                                                                                        Delete
                                                                                                        Beneficiary &nbsp;
                                                                                                        <i
                                                                                                            className="fa fa-trash"/>
                                                                                                    </button>
                                                                                                </>

                                                                                            )}
                                                                                        </TableCell>
                                                                                    )}

                                                                                </TableRow>
                                                                                    ))}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </CardContent>
                                                            </CardActionArea>
                                                            <CardActions>
                                                            </CardActions>
                                                        </Card>
                                                    </div>

                                                </div>
                                            )}

                                            <hr/>
                                            <div className="row mt-2 mb-5">
                                                <div className="col-md-4">
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        Date Created: &nbsp;{policy.created_at}
                                                    </Typography>
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        Created By: &nbsp;{policy.created_by}
                                                    </Typography>
                                                </div>
                                                <div className="col-md-4">
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        Date Modified: &nbsp;{policy.updated_at}
                                                    </Typography>
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        Modified By: &nbsp;{policy.modified_by}
                                                    </Typography>
                                                </div>

                                            </div>
                                            <hr/>
                                            <div className="row mt-1">
                                                <div className="col-md-4">
                                                    <button onClick={handlePrintOpen}
                                                            className="btn btn-sm btn-primary">
                                                        Print Summary&nbsp;<i className="fa fa-print"/>
                                                    </button>
                                                </div>
                                            </div>

                                            {/*print modal*/}
                                            <Modal
                                                open={printOpen}
                                                onClose={handlePrintClose}
                                                aria-labelledby="simple-modal-title"
                                                aria-describedby="simple-modal-description"
                                            >
                                                <div style={printModalStyle} className={classes.printPaper}>
                                                    <>
                                                        <IlifaSummaryToPrint/>
                                                    </>
                                                </div>
                                            </Modal>
                                            {/*edit beneficiary*/}
                                            <Modal
                                                open={open}
                                                onClose={handleClose}
                                                aria-labelledby="simple-modal-title"
                                                aria-describedby="simple-modal-description"
                                            >
                                                <div style={modalStyle} className={classes.paper}>
                                                    {updateBeneficiaryLoading && (
                                                        <div className="container">
                                                            <form className="loader">
                                                                <div className="login-wrap p-5 mt-5">
                                                                    <Spinner
                                                                        size="medium"
                                                                        message="Updating Beneficiary, Please Wait..."
                                                                        line-fg-color="#64c3c2"
                                                                    />
                                                                </div>
                                                            </form>
                                                        </div>
                                                    )}
                                                    {!updateBeneficiaryLoading && (
                                                        <>
                                                            <h2 id="simple-modal-title">Edit Beneficiary</h2>
                                                            <form className={classes.root1} noValidate
                                                                  autoComplete="off">
                                                                <TextField id="standard-basic" label="Name"
                                                                           value={beneficiary.name}
                                                                           onChange={handleBeneficiaryChange('name')}
                                                                />
                                                                <TextField id="standard-basic" className="ml-2"
                                                                           label="Surname"
                                                                           value={beneficiary.surname}
                                                                           onChange={handleBeneficiaryChange('surname')}
                                                                />
                                                                <TextField id="standard-basic" type="number"
                                                                           className="ml-2"
                                                                           label="Contact"
                                                                           value={beneficiary.mobile_number}
                                                                           onChange={handleBeneficiaryChange('mobile_number')}
                                                                />
                                                            </form>
                                                            <form className={classes.root1} noValidate
                                                                  autoComplete="off">
                                                                <TextField id="standard-basic" className=""
                                                                           label="Relationship"
                                                                           value={beneficiary.relationship}
                                                                           onChange={handleBeneficiaryChange('relationship')}
                                                                           readOnly
                                                                />
                                                                <TextField id="standard-basic" className="ml-2"
                                                                           label="ID Number"
                                                                           value={beneficiary.id_number}
                                                                           onChange={handleBeneficiaryChange('id_number')}
                                                                />
                                                            </form>
                                                            <form className={classes.root1} noValidate
                                                                  autoComplete="off">
                                                                <InputLabel htmlFor="dob">Date Of Birth</InputLabel>
                                                                <TextField id="dob" fullWidth={false} type="date"
                                                                           value={beneficiary.date_of_birth}
                                                                           onChange={handleBeneficiaryChange('date_of_birth')}
                                                                />
                                                            </form>
                                                            <button onClick={handleUpdateBeneficiary}
                                                                    className="btn btn-sm btn-primary">
                                                                update &nbsp; <i className="fa fa-refresh"/>
                                                            </button>
                                                            <button onClick={handleClose}
                                                                    className="btn btn-sm btn-warning">
                                                                Cancel &nbsp; <i className="fa fa-close"/>
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </Modal>
                                            {/*add beneficiary*/}
                                            <Modal
                                                open={beneficiaryOpen}
                                                onClose={handleBeneficiaryClose}
                                                aria-labelledby="simple-modal-title"
                                                aria-describedby="simple-modal-description"
                                            >
                                                <div style={modalStyle} className={classes.paper}>
                                                    {addBeneficiaryLoading && (
                                                        <div className="container">
                                                            <form className="loader">
                                                                <div className="login-wrap p-5 mt-5">
                                                                    <Spinner
                                                                        size="medium"
                                                                        message="Submitting Data, Please Wait..."
                                                                        line-fg-color="#64c3c2"
                                                                    />
                                                                </div>
                                                            </form>
                                                        </div>
                                                    )}
                                                    {!addBeneficiaryLoading && (
                                                        <>
                                                            <h2 id="simple-modal-title">Add Beneficiary</h2>
                                                            <form className={classes.root1} noValidate
                                                                  autoComplete="off">
                                                                <TextField id="standard-basic" label="Name"
                                                                           onChange={handleBeneficiaryChange('name')}
                                                                />
                                                                <TextField id="standard-basic" className="ml-2"
                                                                           label="Surname"
                                                                           onChange={handleBeneficiaryChange('surname')}
                                                                />
                                                                <TextField id="standard-basic" type="number"
                                                                           className="ml-2"
                                                                           label="Contact"
                                                                           onChange={handleBeneficiaryChange('mobile_number')}
                                                                />
                                                            </form>
                                                            <form className={classes.root1} noValidate
                                                                  autoComplete="off">
                                                                <TextField id="standard-basic" className=""
                                                                           label="Relationship"
                                                                           onChange={handleBeneficiaryChange('relationship')}
                                                                />
                                                                <TextField id="standard-basic" className="ml-2"
                                                                           label="ID Number"
                                                                           onChange={handleBeneficiaryChange('id_number')}
                                                                />
                                                            </form>
                                                            <form className={classes.root1} noValidate
                                                                  autoComplete="off">
                                                                <InputLabel htmlFor="dob">Date Of Birth</InputLabel>
                                                                <TextField id="dob" fullWidth={false} type="date"
                                                                           onChange={handleBeneficiaryChange('date_of_birth')}
                                                                />
                                                            </form>
                                                            <button onClick={handleAddBeneficiary}
                                                                    className="btn btn-sm btn-primary">
                                                                Submit &nbsp; <i className="fa fa-send"/>
                                                            </button>
                                                            <button onClick={handleBeneficiaryClose}
                                                                    className="btn btn-sm btn-warning">
                                                                Cancel &nbsp; <i className="fa fa-close"/>
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </Modal>


                                        </div>

                                    </div>
                                </div>

                            </div>
                        )}
                    </div>
                )}

            </div>
        </div>
    )
}

export default ViewNhakaYangu;

